import { render, staticRenderFns } from "./AppointmentCalendar.vue?vue&type=template&id=274f3f00&"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=js&"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports